const SERVER_URL = 'https://127.0.0.1/agente/clisitef';
const CONFIGURATION = 'https://devbackbr.gipsyy.com/api/GipsyyWeb';

const Pinpad = {
  CreateSessionId: () => `${SERVER_URL}/session`,
  destroySessionId: () => `${SERVER_URL}/session`,
  getSessionId: () => `${SERVER_URL}/session`,
  getState: () => `${SERVER_URL}/state`,
  getVersion: () => `${SERVER_URL}/getVersion`,
  start: () => `${SERVER_URL}/startTransaction`,
  finish: () => `${SERVER_URL}/finishTransaction`,
  continue: () => `${SERVER_URL}/continueTransaction`,
  open: () => `${SERVER_URL}/pinpad/open`,
  close: () => `${SERVER_URL}/pinpad/close`,
  isPresent: () => `${SERVER_URL}/pinpad/isPresent`,
  config: () => `${CONFIGURATION}/AgencySitefTerminal/Configuration`,
  installments: () => `/AgencySitefTerminal/Installments`,
};

export default Pinpad;
